import React from 'react';
var AmountInputFormatContext = /*#__PURE__*/React.createContext(true);
var AmountInputFormatProvider = AmountInputFormatContext.Provider,
  AmountInputFormatConsumer = AmountInputFormatContext.Consumer;
export { AmountInputFormatProvider };
export { AmountInputFormatConsumer };
export default AmountInputFormatContext;